import {UmpireImage} from '../umpire-image';
import {Language} from '../umpire-language-service';
import {UmpireOttEvent} from '../umpire-ott-event';
import {UmpireOttPlaylistResourceKind} from '../umpire-ott-playlist-resource-kind';
import {UmpirePublicationOptions} from '../umpire-publication-options';
import {UmpireTag} from '../umpire-tag';

export class UmpireOttPlaylist implements UmpirePublicationOptions {
  name!: string;

  resources_kind!: UmpireOttPlaylistResourceKind;

  playlist_events!: UmpireOttEvent[];

  events!: UmpireOttEvent[];

  playlist_tags!: UmpireTag[];

  type!: 'playlist';

  author!: string;

  events_count!: number;

  id!: string;

  slug!: string | null;

  image!: UmpireImage;

  image_vertical!: UmpireImage;

  image_horizontal!: UmpireImage;

  tags!: UmpireTag[];

  publication_time!: string | null;

  published_at!: string | null;

  is_draft!: boolean;

  locale!: Language;

  available_translations!: Language[];
}
